export default "__VITE_ASSET__jCwzq$7K__"